export const packageIdentity = Object.freeze({
    name: "@gordonland/ui",
    stage: "p0-public-contract",
});
export { UI_CONTRACT_V1 } from "./contracts.js";
